var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHomeActive = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "Group 22") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Home",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-22"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24,0 L24,24 L0,24 L0,0 L24,0 Z",
  id: "Vector",
  opacity: 0
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.93340264,2.80362009 L2.99049839,8.87836291 L2.84540893,9.01406139 C2.29806232,9.56613709 2.00073066,10.2615356 2,10.9874115 L2,19.4579394 L2.0055362,19.6255114 C2.11823832,21.2116586 3.55856063,22.400034 5.26712011,22.400034 L9.33923435,22.400034 C9.70772781,22.400034 10.0064668,22.1013414 10.0065241,21.7328479 L10.0074774,15.6001371 L10.0128342,15.5031868 C10.0430178,15.1953154 10.3302872,14.9327436 10.6747672,14.9327436 L13.7252348,14.9327436 L13.8220814,14.9381003 C14.1299527,14.9682839 14.3925245,15.2555533 14.3925245,15.6000334 L14.3915713,21.7326405 C14.391514,22.101215 14.6902866,22.400034 15.0588611,22.400034 L19.1328818,22.400034 L19.3154559,22.3953115 C21.0353761,22.301647 22.4000019,21.0354016 22.4000019,19.4579394 L22.4000019,10.9880828 L22.3925033,10.7961963 C22.3306441,10.0482575 21.9795887,9.37655609 21.4091935,8.8780918 L14.4766227,2.81221676 L14.2862706,2.6625227 C13.0053411,1.73053713 11.144318,1.78568526 9.93340264,2.80362009 Z",
  id: "Home",
  fill: "#6659FF",
  fillRule: "nonzero"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgHomeActive);
export default ForwardRef;